module.exports = __webpack_public_path__ + "static/media/cartilage.1f583cdb.png";